import React, { useEffect, useRef, useState } from 'react';
import { Button, Popover } from 'antd';
import {useNavigate} from 'react-router-dom';
import { InfoCircleOutlined, InfoCircleTwoTone } from '@ant-design/icons';
import Spinner from '../spinner';
import { ArrowUpRightFromSquare } from 'lucide-react';
import { FloatingHelp } from "@src/components/helpLink/floatingHelp";

// helpSlug: the page's Help article(s) (/user/help/<slug>), listed by the floating "?" button
// along with Lists, views and filters, which every list page uses
export const GridHeader = ({title, btnText, record, createAction, actionBtnHide=false, help=false, loading=false, mapBtn, helpSlug})=>{

    const [isAction, setAction] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
      const handleOutsideClick = (event) => {
        if (containerRef.current && !containerRef.current.contains(event.target)) {
            setAction(false);
        }
      };
  
      document.addEventListener('click', handleOutsideClick);
  
      return () => {
        document.removeEventListener('click', handleOutsideClick);
      };
    }, []);

    const navigate = useNavigate();

    return(
        <>
            {helpSlug && <FloatingHelp slugs={[...[helpSlug].flat(), "data-views-filters"]} />}
            <div className='grid-head-section'>
                <div className='grid-title'>
                    {title}  
                    <span className='grid-subtitle'>
                     {" - "+(record || 0)} records  
                        {/* {help &&
                            <Popover
                                placement='right'
                                content={"This view shows all records associated with the duties. However, the list may not display them all at once, since additional records are only revealed after the duty’s clock-in has been completed."}
                            >
                                <InfoCircleTwoTone size={10}/>
                            </Popover>
                        }  */}

                    </span>
                    {/* <div className='grid-subtitle'>
                        
                    </div> */}
                </div>
                {/* right section */}
                {actionBtnHide? 
                    null
                :
                    <div className='grid-header-btn'>
                        
                        
                        {/* <div className="dropdown" ref={containerRef}>
                        <Button className='grid-outlined-btn dropdown' onClick={()=>setAction(!isAction)}>Action <span className='private-dropdown__caret'></span></Button>
                            <div  className="dropdown-content" style={isAction ? {display:'block'}: {display:'none'}}>
                            <a href="" className='disabled' onClick={(e)=>{ e.preventDefault(); setFieldModal(true); }}
                            >Create properties</a>
                            <Link to="/setting" target='_blank'
                            >Edit properties</Link>
                            <a href="" className='disabled'  onClick={(e)=>{
                                e.preventDefault();
                                navigate(to,{
                                    state: {
                                    title,
                                    url:from,
                                    }
                                })}}>View Customization</a>
                            <a href="#">Restore records</a>
                            </div>
                        </div>
                        <Button className='grid-outlined-btn'>Import</Button> */}
                 

                        {
                            mapBtn &&
                            <Button className='grid-outlined-btn' onClick={()=>navigate("/user/employeemap")}>Map View <ArrowUpRightFromSquare size={15}/> </Button>
                        }


                        <Button className='grid-filed-btn' onClick={createAction}>Create {btnText||title}</Button>
                    </div>
                }

            </div>
            <div className='dragable-view'>
                {/* dragable tabs implementation */}
            </div>

            
        </>
    )
}